import isNumeric from './is-numeric';

const withUnit = (value, preferredUnit = 'px') => {
  if (isNumeric(value)) {
    return `${value}${preferredUnit}`;
  }

  return value;
};

export default withUnit;
